export default __webpack_public_path__ + "static/media/iheb.74340b26.png";